import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  className: PropTypes.string,
};

const Placeholder = ({ className }) => {
  return (
    <span className={className}>
      <span className="price-display-placeholder">$XX.XX</span>
    </span>
  );
};

Placeholder.propTypes = propTypes;

export default Placeholder;
